import { render, staticRenderFns } from "./SendDocuments.vue?vue&type=template&id=6a7d17ef&scoped=true&"
import script from "./SendDocuments.vue?vue&type=script&lang=ts&"
export * from "./SendDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocuments.vue?vue&type=style&index=0&id=6a7d17ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d17ef",
  null
  
)

export default component.exports